<template>
  <b-form-group :disabled="disabled">
    <b-input-group :style="inputStyle">
      <masked-input
        ref="cadastroFederal"
        v-model="cnpjInput"
        :class="{'is-invalid' : cnpjIsInvalid > 0}"
        :mask="mascaraCadFederal"
        class="form-control"
        @input="realizarBusca(cnpjInput)"
      />
      <b-btn
        id="cnpj-add"
        variant="none"
        title="Adicionar"
        class="btn-primary"
        :disabled="cnpjInvalido"
        @click="atualizarCnpjs"
      >
        <feather-icon
          style="color:#ffffff;"
          icon="PlusIcon"
        />
      </b-btn>
    </b-input-group>
    <small
      v-if="cnpjIsInvalid"
      class="text-danger"
    >{{ cnpjMatriz ? 'Somente é permitido um CNPJ Matriz por proposta!' : 'CNPJ Inválido' }}</small>
    <small
      v-else-if="cnpjDuplicado"
      class="text-danger"
    >CNPJ Duplicado!</small>
    <div style="margin-top:5px;">
      <div
        v-for="(item, $index) in cnpjs"
        :key="item"
      >
        <b-badge class="badge-cnpj-list">
          <span
            class="mr-50"
            style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;"
          >{{ formatCnpjResposta(item) }}</span>
          <b-btn
            style="padding: 2px"
            variant="none"
            title="Excluir"
            @click="remover($index)"
          >
            <feather-icon
              icon="XIcon"
            />
          </b-btn>
        </b-badge>
      </div>
    </div>
  </b-form-group>
</template>

<style lang="scss" scoped>
#cnpj-add{
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  padding-left: 15px;
  padding-right: 15px;
}

.badge-cnpj-list {
  background-color: rgb(0, 204, 102);
  font-size: 78%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: fit-content;
  margin-bottom: 0.3rem;
}
</style>

<script>
import { mapActions } from 'vuex'
import { cnpj } from 'cpf-cnpj-validator'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'MultiCnpjInput',
  props: {
    value: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputStyle: {
      type: String,
      default: '',
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cnpj,
      cnpjIsInvalid: false,
      cnpjDuplicado: false,
      cnpjMatriz: false,
      cnpjInput: '',
      cnpjs: [],
    }
  },
  computed: {
    cnpjInvalido: {
      get() {
        return !(this.cnpjInput ? this.cnpjInput.replace(/\D/g, '').length === 14 : false)
      },
    },
  },
  created() {
    if (this.value != null) {
      this.cnpjs = this.value
    }
  },
  methods: {
    ...mapActions('proposta', ['setCnpjInput']),
    mascaraCadFederal() {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    /* eslint no-underscore-dangle: 0 */
    atualizarCnpjs() {
      this.$isLoading(true)
      if (this.cnpj.isValid(this.cnpjInput)) {
        const duplicado = this.cnpjs.find(f => f.includes(this.cnpjInput))
        if (duplicado != null) {
          this.cnpjDuplicado = true
          this.$isLoading(false)
        } else {
          api.buscarRazaoSocialCnpj(this.cnpjInput, this.externo)
            .then(response => {
              if (response.data != null) {
                const isMatriz = response.data.includes('Matriz')
                if (isMatriz && this.cnpjs.filter(fil => fil.includes('Matriz')).length > 0) {
                  this.$erro('Somente é permitido um CNPJ de Matriz por proposta! Contate nossos analistas para mais informações.')
                  this.cnpjIsInvalid = true
                  this.cnpjMatriz = true
                  this.$isLoading(false)
                  return
                }

                this.cnpjs.push(response.data)
                this.cnpjInput = ''
                this.$emit('atualizar-cnpjs', this.cnpjs)
                this.setCnpjInput('')
              }
            })
            .catch(err => {
              this.$erro(err)
              throw err
            })
            .finally(() => {
              this.$isLoading(false)
            })
        }
        this.cnpjIsInvalid = false
        this.cnpjMatriz = false
      } else {
        this.cnpjIsInvalid = true
        this.cnpjMatriz = false
        this.$isLoading(false)
      }
    },
    formatCnpjResposta(value) {
      return `${value.replaceAll(',', ' - ')}`
    },
    remover(index) {
      this.$confirmar('Deseja realmente excluir o CNPJ?', 'Atenção: caso o checklist já tenha sido respondido e essa remoção altere o tipo "Filial, Matriz ou Matriz e Filial" será excluído o checklist anterior e gerado um novo para preenchimento!', 'question', 'danger')
        .then(result => {
          if (result.value) {
            this.cnpjs.splice(index, 1)
            this.$emit('atualizar-cnpjs', this.cnpjs)
          }
        })
    },
    realizarBusca(value) {
      this.setCnpjInput(value)
      this.atualizarCnpjs()
    },
  },
}
</script>
